@if (sanitizedUrl()) {
  <iframe
    [src]="sanitizedUrl()"
    title="Trapo2"
    style="flex: 1; border: unset"
  ></iframe>
}
